import { useState, useEffect } from 'react';

const useCurrentLocation = () => {
    const [location, setLocation] = useState({
        latitude: null,
        longitude: null,
        error: null,
        loading: true,
    });

    const requestLocation = () => {
        if (!navigator.geolocation) {
            setLocation({
                latitude: null,
                longitude: null,
                error: 'Geolocation is not supported by your browser.',
                loading: false,
            });
            return;
        }

        setLocation((prev) => ({ ...prev, loading: true }));

        const handleSuccess = (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({
                latitude,
                longitude,
                error: null,
                loading: false,
            });
        };

        const handleError = (error) => {
            setLocation({
                latitude: null,
                longitude: null,
                error: error.message,
                loading: false,
            });
        };

        navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
    };

    useEffect(() => {
        requestLocation();
    }, []);

    return { ...location, requestLocation };
};

export default useCurrentLocation;
